<div class="server-is-down-content">
    <div class="server-down-dialog-title">The connection has been lost.</div>
    <div class="server-down-dialog-title">Attempting to reconnect...</div>
    <div class="server-down-dialog-text">Connection attempt: {{dialogConfig.dialogData.retryCounter | async}}
        of {{dialogConfig.dialogData.retries}}
        <ac-progress [center]="false" size="small"></ac-progress>
    </div>
</div>
